import React, { useState } from 'react';
import { useQuery } from '@apollo/client';

import { FETCH_UNIFIED_CONTACTS } from '@/services/unifiedContacts';
import { onCompletedHandler } from '@/services/apollo';

import { extractStatistics } from '../helpers';
import EndCardHeader from './EndCardHeader';

function EndCard() {
    const [isError, setIsError] = useState(false);
    const [contactsCircle, setContactsCircle] = useState({});

    const { loading } = useQuery(FETCH_UNIFIED_CONTACTS, {
        variables: {
            sortColumn: null,
            sortDirection: null,
            visible: null,
            circle: null,
            keyword: '',
        },
        notifyOnNetworkStatusChange: true,
        fetchPolicy: 'no-cache',
        onCompleted: onCompletedHandler(setIsError, (info) => {
            setContactsCircle(
                extractStatistics(info.user.unifiedContacts),
            );
        }),
    });

    return (
        <EndCardHeader
            contactsCircle={contactsCircle}
            loading={loading}
            isError={isError}
        />
    );
}

export default EndCard;
